import { useMemo } from 'react';

import { sectionTypeDisplayInfos } from '@/entities/section-plan/model/section-type';

interface UseModeSwitcherLogicProps {
	sectionType: string;
	sectionRounds: number | null;
}

export function useModeSwitcherLogic({ sectionType, sectionRounds }: UseModeSwitcherLogicProps) {
	return useMemo(() => {
		const { coreModel } =
			sectionTypeDisplayInfos[sectionType as keyof typeof sectionTypeDisplayInfos];
		const { supportedRepetitionModesForItsStepPlans } = coreModel;

		// Don't show the switcher for section types that don't support explicit mode
		const shouldShowModeSwitcher = supportedRepetitionModesForItsStepPlans('explicit') !== false;

		// For circuit and superset, disable if no rounds are set
		const isDisabled =
			(sectionType === 'circuit' || sectionType === 'superset') && sectionRounds === null;

		return {
			shouldShowModeSwitcher,
			isDisabled,
		};
	}, [sectionType, sectionRounds]);
}
